import 'imports-loader?this=>window!sidr/dist/jquery.sidr.js'

$(function() {
    $('#sidr-menu').sidr();
    $('#pop-master-view-sider').sidr({
        name: 'sidr-right',
        side: 'right'
    });
    $('#sidr li:not(.login)').click(function(){
        window.location = $(this).find('a').attr('href');
    });

    $('.sidr').css('display','block');
});
